import { render, staticRenderFns } from "./groupDia.vue?vue&type=template&id=0729f3d4&scoped=true&"
import script from "./groupDia.vue?vue&type=script&lang=js&"
export * from "./groupDia.vue?vue&type=script&lang=js&"
import style0 from "./groupDia.vue?vue&type=style&index=0&id=0729f3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0729f3d4",
  null
  
)

export default component.exports